"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const constants_1 = require("../../lib/constants");
const messages_1 = require("../../lib/messages");
const styles_1 = require("./styles");
function ShowMoreShowLess({ id, state, send, log }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        state.matches(`${constants_1.states.expandable}.${constants_1.states.contracted}`) && (react_1.default.createElement(styles_1.ShowMoreButtonContainer, null,
            react_1.default.createElement(button_1.default, { "data-testid": `ShowMoreButton-${id}`, mode: "secondary", onClick: () => {
                    log(constants_1.logging.userShowMore(id));
                    send({
                        type: constants_1.events.SHOW_MORE
                    });
                } },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.messages.infoListBoxShowMore))))),
        state.matches(`${constants_1.states.expandable}.${constants_1.states.expanded}`) && (react_1.default.createElement(styles_1.ShowMoreButtonContainer, null,
            react_1.default.createElement(button_1.default, { "data-testid": `ShowLessButton-${id}`, mode: "secondary", onClick: () => {
                    send({
                        type: constants_1.events.SHOW_LESS
                    });
                } },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.messages.infoListBoxShowLess)))))));
}
exports.default = ShowMoreShowLess;
//# sourceMappingURL=ShowMoreShowLess.js.map